export enum FormType {
  FORM_1065 = 'FORM_1065',
  FORM_1120S = 'FORM_1120S',
  FORM_1120 = 'FORM_1120',
  SCHEDULE_C = 'SCHEDULE_C',
  FORM_1040 = 'FORM_1040',
  FORM_990 = 'FORM_990',
  OTHER = 'OTHER'
}
